<script setup lang="ts">
import type { LinkDragOptions, LinkDragRef } from "@/composables/linkDrag";
import { startLinkDrag } from "@/composables/linkDrag";

const props = defineProps<{ source: LinkDragRef; options: LinkDragOptions }>();

function onPointerDown(event: PointerEvent) {
  startLinkDrag(event, props.source, props.options);
}
</script>

<template>
  <div
    class="link-drag"
    data-no-screenshot
    data-no-animate
    aria-hidden="true"
    @pointerdown="onPointerDown"
    @click.stop
  >
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 17">
      <circle cx="5" cy="12" r="4.5" stroke="currentColor" />
      <path fill="currentColor" d="M4.5 0h1v8h-1z" />
    </svg>
  </div>
</template>

<style lang="scss" scoped>
@use "@/styles/variables/colors";

// Sizing and positioning are the caller's responsibility.
.link-drag {
  cursor: grab;
  touch-action: none;
  color: colors.$main;

  svg {
    pointer-events: none;
  }
}
</style>
